<template>
  <div ref='bulkMySharingModal' aria-hidden="true" class="modal fade hidden always-on-top" role="dialog" tabindex='-1'>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">
            <img src="../../assets/shared.svg"/>
            {{ $t('share_invite.edit_share_for', { foldersCount: folderIds().length }) }}
          </h5>
        </div>
        <div class="modal-body">
          <div class="sharing-modal-wrapper">
            <label>
              Email sharing for
              <strong>{{ folderNames() }}</strong>
            </label>
            <a href="#" v-if="all_folders" @click.prevent="toggleShowFolders()">
              show less
            </a>
            <a href="#" v-if="!all_folders && foldersList.length > folder_limit " @click.prevent="toggleShowFolders()">
              + ({{ foldersList.length - folder_limit }}) folders
            </a>
            <div class="text-center">
              <loading v-if="loading"/>
              <table class="table" v-if="loading === false && myShareInvites.length > 0">
                <thead>
                <tr>
                  <th><input type='checkbox' @input='selectAll' :disabled="filteredItems.length === 0"/></th>
                  <th colspan="2">
                    <div class="btn-group dropdown float-left" role="group" aria-expanded="false">
                      <button :class="['btn', 'btn-neutral', 'dropdown-toggle', { disabled: !isBulkEnabled }]"
                              aria-expanded="false"
                              aria-haspopup="true" data-toggle="dropdown">
                        {{ $t('records_list.dropdown.bulk_actions') }}
                      </button>
                      <div class="dropdown-menu">
                        <ul>
                          <li>
                            <a @click.prevent="changePermission(myShareInviteIds, 'read')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-eye"></i>
                              {{ $t('share_invite.can_read') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(myShareInviteIds, 'write')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-edit"></i>
                              {{ $t('share_invite.can_edit') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(myShareInviteIds, 'all')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-medal"></i>
                              {{ $t('share_invite.extended_write') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(myShareInviteIds, 'delete')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-users-slash"></i>
                              {{ $t('share_invite.unshare') }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-8 float-left">
                    <div class="search-container-wrapper"
                         v-if="myShareInvites.length !== 0">
                      <i class="fas fa-search"></i>
                      <i class="fas fa-times" v-if="searchTerm.length > 0" @click.prevent="searchTerm = ''"></i>
                      <input
                          type="text"
                          name="search"
                          v-model="searchTerm"
                          class="form-control search-field"
                          autocomplete="off"
                          :placeholder="$t('share_invite.search')"/>
                      <div class="clearfix"></div>
                    </div>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody v-if="filteredItems.length > 0">
                <tr v-for='share_invite in filteredItems' :key='share_invite.id'>
                  <td class="bulk-check">
                    <input type='checkbox' v-model='bulkOpShareInvites' :value='share_invite'/>
                  </td>
                  <td class="shared-invite-line">
                    <img src="../../assets/no-picture.svg"/>
                    <div class="shared-invite-body">
                      <b>{{ share_invite.contact_name }}</b>
                      <br/>
                      {{ share_invite.contact_email }}
                    </div>
                  </td>
                  <td class="shared-invite-options">
                    <div class="btn-group dropdown float-left m-r-10" role="group" aria-expanded="false">
                      <button :class="['btn', 'btn-neutral', 'dropdown-toggle']" aria-expanded="false"
                              aria-haspopup="true" data-toggle="dropdown">
                        <span v-if="share_invite.invite_types.length > 1">{{ $t('share_invite.varies' ) }}</span>
                        <span v-else-if="share_invite.invite_types.includes('read')">{{ $t('share_invite.can_read' ) }}</span>
                        <span v-else-if="share_invite.invite_types.includes('write')">{{ $t('share_invite.can_edit' ) }}</span>
                        <span v-else-if="share_invite.invite_types.includes('all')">{{ $t('share_invite.extended_write' ) }}</span>
                      </button>
                      <div class="dropdown-menu">
                        <ul>
                          <li>
                            <a @click.prevent="changePermission(share_invite.share_invite_ids, 'read')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-eye"></i>
                              {{ $t('share_invite.can_read') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(share_invite.share_invite_ids, 'write')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-edit"></i>
                              {{ $t('share_invite.can_edit') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(share_invite.share_invite_ids, 'all')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-medal"></i>
                              {{ $t('share_invite.extended_write') }}
                            </a>
                          </li>
                          <li>
                            <a @click.prevent="changePermission(share_invite.share_invite_ids, 'delete')" href="#"
                               class="dropdown-item">
                              <i class="fas fa-users-slash"></i>
                              {{ $t('share_invite.unshare') }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="empty-list-wrapper" v-if="loading === false && filteredItems.length === 0">
              <div class="clearfix"></div>
              <img src="../../assets/empty_states/shared_with_me.png"/>
              <p>{{ $t('root.no_data_filters') }}</p>
            </div>
          </div>
        </div>
        <div class='modal-footer'>
          <a @click.prevent="close()" class="btn btn-outline-primary float-right" href="">{{ $t('share_invite.close') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _loading from '../_loading'

  export default {
    components: {
      loading: _loading
    },
    props: {
      folders: {
        type: Array,
        required: true
      },
      folder_limit: {
        type: Number,
        required: false,
        default: 3
      }
    },
    data: function () {
      return {
        invites: [],
        all_folders: false,
        limit: this.$props.folder_limit,
        bulkOpShareInvites: [],
        loading: false,
        searchTerm: ''
      }
    },
    created() {
      this.loadMyShareInvites()
    },
    computed: {
      myShareInviteIds() {
        return this.bulkOpShareInvites.map(f => f.share_invite_ids).flat()
      },
      myShareInvites() {
        return this.lists.myShareInvites || {}
      },
      foldersList() {
        return this.$props.folders
      },
      isBulkEnabled() {
        return this.bulkOpShareInvites.length > 0
      },
      filteredItems() {
        let share_invites = this.myShareInvites
        if (this.searchTerm !== null && this.searchTerm.length > 0) {
          return share_invites.filter(v => {
            let s = v.contact_name.toLowerCase().indexOf(this.searchTerm) !== -1
            s = s || v.contact_email.toLowerCase().indexOf(this.searchTerm) !== -1
            return s
          })
        } else {
          return share_invites
        }
      }
    },
    methods: {
      selectAll(e) {
        if (e.target.checked) {
          this.bulkOpShareInvites = this.filteredItems.slice()
        } else {
          this.bulkOpShareInvites = []
        }
      },
      toggleShowFolders() {
        if (this.all_folders === false) {
          this.limit = this.foldersList.length
          this.all_folders = true
        } else {
          this.limit = this.$props.folder_limit
          this.all_folders = false
        }
      },
      loadMyShareInvites() {
        if (this.folderIds().length === 0)
          return []

        const params = {folder_ids: this.folderIds()}

        this.loading = true
        return this.listStore.getMyShareInvites(params).then(res => {
          this.loading = false
        })
      },
      open() {
        this.loadMyShareInvites().then(data => {
          $(this.$refs.bulkMySharingModal).modal('show')
        })
      },
      close() {
        $(this.$refs.bulkMySharingModal).modal('hide')
      },
      folderIds() {
        return this.foldersList.map(f => f.id)
      },
      folderNames() {
        return this.$props.folders.slice(0, this.limit).map(f => f.name).join(', ')
      },
      hasShared() {
        return this.shared.length == 0
      },
      shared() {
        return this.bulkOpFolders.filter((item) => item.shared === true)
      },
      hasShareInvites() {
        return this.share_invites && this.share_invites.length === 0
      },
      changePermission(share_invite_ids, invite_type) {
        const params = {share_invite_ids: share_invite_ids, invite_type: invite_type}
        if (invite_type === 'delete') {
          this.axios.post('/my_share_invites/bulk_destroy', params)
            .then(res => {
              this.$emit('success')
              this.bulkOpShareInvites = []
              this.loadMyShareInvites()
              this.$toastr.success(this.$t('share_invite.access_revoked'))
              this.store.sendMetrics({
                name: 'bulk_revoke_sharing_my_shared_folders',
                params: params,
                path: this.$route.fullPath
              })
            })
        } else {
          this.axios.patch('/my_share_invites/bulk_update', params)
            .then(res => {
              this.$emit('success')
              this.bulkOpShareInvites = []
              this.loadMyShareInvites()
              this.$toastr.success(this.$t('share_invite.perm_updated'))
              this.store.sendMetrics({
                name: 'bulk_edit_sharing_my_shared_folders',
                params: params,
                path: this.$route.fullPath
              })
            })
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
.search-container-wrapper
  width: 50%
  position: relative
  float: left
  .fa-search
    top: 7px
    left: 10px
  input
    font-family: 'Quicksand', sans-serif
    height: 43px
    font-size: 14px
    font-weight: 500
  i
    position: absolute
    opacity: 0.4

    &.fa-search
      left: 9px
      top: 13px
      font-size: 18px

    &.fa-times
      right: 13px
      top: 14px
      font-size: 16px
      cursor: pointer
  input
    padding-left: 40px
    border: 1px solid #c4c4c4

    &::placeholder
      font-size: 14px
      color: #a4a4a4

.filter-link
  padding: 20px 0 0 50px
.shared-invite-line
  img
    float: left
    margin-right: 10px
    margin-left: 10px
.shared-invite-options select
  cursor: pointer
table
  th
    .input-group
      width: 33%
      button
        color: #b4b4b4
        background-color: #EFEFEF
        border-left: none
      input
        border-right: none
        border-radius: .25rem 0 0 .25rem
    .filter
      margin-left: 10px
</style>
